/* Scroll reveal for motion.css.
   Adds .is-revealed when an element enters the viewport (staggered when several
   appear at once), then .reveal-done so hover transitions are not slowed down. */
(function () {
  'use strict';

  var root = document.documentElement;
  if (!root.classList.contains('motion-ready')) return;

  var SELECTOR = [
    'main h1', 'main h2', 'main h3',
    'main .subtitle',
    'main .rich-text__text',
    'main .button--primary',
    'main .button--arrow',
    'main .flavor-pack',
    'main .multicolumn-card',
    'main .card--product',
    'main .pack-feature__media',
    'main .image-with-text__image'
  ].join(',');

  var REVEAL_MS = 900;
  var STAGGER_MS = 80;
  var MAX_STAGGER = 5;

  function finish(el, delay) {
    window.setTimeout(function () {
      el.style.transitionDelay = '';
      el.classList.add('reveal-done');
    }, REVEAL_MS + delay + 150);
  }

  function reveal(el, index) {
    var delay = Math.min(index, MAX_STAGGER) * STAGGER_MS;
    el.style.transitionDelay = delay + 'ms';
    el.classList.add('is-revealed');
    finish(el, delay);
  }

  var observer = new IntersectionObserver(
    function (entries) {
      var index = 0;
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        reveal(entry.target, index);
        index += 1;
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
  );

  function observeAll(scope) {
    (scope || document).querySelectorAll(SELECTOR).forEach(function (el) {
      if (el.classList.contains('is-revealed') || el.classList.contains('reveal-done')) return;
      observer.observe(el);
    });
  }

  observeAll();

  // Theme editor: new or re-rendered sections get revealed too.
  document.addEventListener('shopify:section:load', function (event) {
    observeAll(event.target);
  });

  window.__motionBooted = true;
})();
